import { render } from "./AppointmentTab.vue?vue&type=template&id=3306fc2e&scoped=true"
import script from "./AppointmentTab.vue?vue&type=script&lang=js"
export * from "./AppointmentTab.vue?vue&type=script&lang=js"

import "./AppointmentTab.vue?vue&type=style&index=0&id=3306fc2e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3306fc2e"]])

export default __exports__